import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faHouseChimneyMedical } from '@fortawesome/pro-solid-svg-icons/faHouseChimneyMedical'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faUserDoctor } from '@fortawesome/pro-solid-svg-icons/faUserDoctor'

const iconColorMapping = {
  Foundation: {
    color: 'bg-warm700',
    icon: faHouseChimneyMedical,
  },
  Patient: {
    color: 'bg-hope800',
    icon: faUser,
  },

  Supplier: {
    color: 'bg-blue600',
    icon: faUserDoctor,
  },
}

export const TestimonialCard = ({
  personName,
  personTitle,
  personType,
  quote,
}: {
  personName: string
  personTitle: string
  personType: 'Patient' | 'Foundation' | 'Supplier'
  quote: string
}) => {
  const { color, icon } = iconColorMapping[personType]

  return (
    <>
      <li className='rounded-xl border border-neutral200 bg-neutral50 p-6'>
        <Text
          className='mb-4 text-neutral700'
          element='p'
          styleName='p'
          value={<span className='leading-relaxed'>{quote}</span>}
        />
        <div className='flex flex-row items-center gap-3'>
          <div
            className={`size-10 rounded-full ${color} flex items-center justify-center`}
          >
            <Icon className='text-white' icon={icon} />
          </div>
          <div className='flex flex-col'>
            <Text
              className='text-neutral900'
              element='p'
              styleName='p-small-strong'
              value={<span className='leading-normal'>{personName}</span>}
            />
            <Text
              className='text-neutral500'
              element='p'
              styleName='p-small'
              value={<span className='leading-normal'>{personTitle}</span>}
            />
          </div>
        </div>
      </li>
    </>
  )
}
